<template>
    <v-container fluid>
    <div v-for="(item,i) in alts" :key="i">
    <v-checkbox
      v-model="selected"
      :label="item.Label"
      :value="item"
    ></v-checkbox>
    </div>
  </v-container>
</template>

<script>
export default {
    props: ['qAObject'],
    data() {
        return {
            selected: [],
            alts: [],
            checkBoxAnswer: [],
            isMandatory: 0,
            surveyValid: false
        }
    },
    watch: {
        selected(checkBoxAnswers,oldVal) {
            // Special case for checkboxes delete oldValue before inserting
            if(oldVal[0]?.QuestionsID != null) {
                oldVal.forEach(element => {
                    this.$store.dispatch('deleteSurveyAnswer', element.QuestionsID);
                });
            }
            

            if(this.isMandatory === 1) {
                if(checkBoxAnswers.length > 0) {
                    this.surveyValid = true;
                } else {
                    this.surveyValid = false;
                }
            } else {
                this.surveyValid = true;
            }
            checkBoxAnswers.forEach(val => {
                let answerObj = { 
                    id: this.questionObject.SurveyID, // SurveyID
                    question: this.questionObject.Topic, //  The actual question
                    answer: val.Label, // the answer
                    type: 'checkbox', // Type of alternativePicker
                    answerId: val.ID, // unique answer id
                    questionId: val.QuestionsID, // unique question id
                    surveyValid: this.surveyValid,
                    isMandatory: this.isMandatory
                };

                this.$store.dispatch('setSurvey', answerObj);
            });
        }
    },
    mounted () {
        this.alts = this.$props.qAObject.alternatives;
        this.questionObject = this.$props.qAObject.question
        this.isMandatory = this.$props.qAObject.question.IsMandatory;
        console.log("isMandatory checkboxes",this.isMandatory);

    }
}
</script>

<style>

</style>